export const OPTIMISER_DRIVER_GET = 'OPTIMISER_DRIVER_GET'
export const OPTIMISER_DRIVER_GET_SUCCESS = 'OPTIMISER_DRIVER_GET_SUCCESS'
export const OPTIMISER_DRIVER_GET_FAILURE = 'OPTIMISER_DRIVER_GET_FAILURE'

export const GET_DRIVER_WARRNING = 'GET_DRIVER_WARRNING'
export const GET_DRIVER_WARRNING_SUCCESS = 'GET_DRIVER_WARRNING_SUCCESS'
export const GET_DRIVER_WARRNING_FAILURE = 'GET_DRIVER_WARRNING_FAILURE'

export const GET_DRIVER_WARRNING_MORE = 'GET_DRIVER_WARRNING_MORE'
export const GET_DRIVER_WARRNING_MORE_SUCCESS = 'GET_DRIVER_WARRNING_MORE_SUCCESS'
export const GET_DRIVER_WARRNING_MORE_FAILURE = 'GET_DRIVER_WARRNING_MORE_FAILURE'

export const GET_DRIVERS_POLARIS = 'GET_DRIVERS_POLARIS'
export const GET_DRIVERS_POLARIS_SUCCESS = 'GET_DRIVERS_POLARIS_SUCCESS '
export const GET_DRIVERS_POLARIS_FAILURE = 'GET_DRIVERS_POLARIS_FAILURE'

export const GET_DRIVERS_POLARIS_LIST_MORE = 'GET_DRIVERS_POLARIS_LIST_MORE'
export const GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS =
  'GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS '
export const GET_DRIVERS_POLARIS_LIST_MORE_FAILURE =
  'GET_DRIVERS_POLARIS_LIST_MORE_FAILURE'

export const PAGE_CHANGED_DRIVERS = 'PAGE_CHANGED_DRIVERS'
export const PAGE_LIMIT_CHANGED_DRIVERS = 'PAGE_LIMIT_CHANGED_DRIVERS'
export const SEARCH_CHANGED_DRIVERS = 'SEARCH_CHANGED_DRIVERS'

export const ADD_DRIVER_POLARIS = 'ADD_DRIVER_POLARIS'
export const ADD_DRIVER_POLARIS_SUCCESS = 'ADD_DRIVER_POLARIS_SUCCESS '
export const ADD_DRIVER_POLARIS_FAILURE = 'ADD_DRIVER_POLARIS_FAILURE'

export const UPDATE_DRIVER_POLARIS = 'UPDATE_DRIVER_POLARIS'
export const UPDATE_DRIVER_POLARIS_SUCCESS = 'UPDATE_DRIVER_POLARIS_SUCCESS '
export const UPDATE_DRIVER_POLARIS_FAILURE = 'UPDATE_DRIVER_POLARIS_FAILURE'

export const REMOVE_ERROR_DRIVERS = 'REMOVE_ERROR_DRIVERS'
export const RESET_SUCCESS_ACTION_DRIVERS = 'RESET_SUCCESS_ACTION_DRIVERS'
export const RESET_CONFIG_DRIVERS = 'RESET_CONFIG_DRIVERS'
